<div class="admin-shell">
  <header class="admin-topbar">
    <div class="admin-brand">
      <span class="brand-mark" aria-hidden="true">P</span>
      <span class="admin-brand-name">Paierly</span>
    </div>

    <div class="admin-account">
      <ng-container *ngIf="currentUser$ | async as user">
        <span class="admin-avatar" aria-hidden="true">{{ initialsFor(user.email) }}</span>
        <span class="admin-account-email">{{ user.email }}</span>
        <button type="button" class="btn btn-ghost btn-sm" (click)="signOut()">
          Sign out
        </button>
      </ng-container>
    </div>
  </header>

  <main class="admin-content">
    <ng-content></ng-content>
  </main>
</div>
